// extracted by mini-css-extract-plugin
module.exports = {"clubBlockFaq__richText--mobile":"ClubBlockFaq_clubBlockFaq__richText--mobile__zS2Mq","clubBlockFaq__image":"ClubBlockFaq_clubBlockFaq__image__gYneP"};